import { render, staticRenderFns } from "./AreaExternaLayout.vue?vue&type=template&id=7b175fb2"
import script from "./AreaExternaLayout.vue?vue&type=script&lang=js"
export * from "./AreaExternaLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports